"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStaticAssetUrl = createStaticAssetUrl;
function createStaticAssetUrl(staticStorageUrl, version, {
  blobPrefix,
  assetName
}) {
  return `${staticStorageUrl}/${blobPrefix}/v${version}/${assetName}`;
}
